import { FeatureFlagsConfig } from 'core/feature-flags/entities';
import {
  didNotOpenReadingExperiment,
  didNotOpenReadingExperimentConfig,
} from './didnotOpenReadingExperiment';
import { openedReadingExperiment, openedReadingExperimentConfig } from './openedReadingExperiment';
import { phoneNumberOptInFeature, phoneNumberOptInFeatureConfig } from './phoneNumberFeature';
import {
  redirectToAsknebulaFeatureConfig,
  redirectToAsknebulaFeatureName,
} from './redirectToAsknebulaFeature';
import {
  requireEmailConsentAsknebulaFeature,
  requireEmailConsentAsknebulaFeatureConfig,
} from './requireEmailConsentAsknebulaFeature';
import {
  requireEmailConsentFeature,
  requireEmailConsentFeatureConfig,
} from './requireEmailConsentFeature';
import {
  restoreSubscriptionExperiment,
  restoreSubscriptionExperimentConfig,
} from './restoreSubscriptionExperiment';
import { solidFormExperiment, solidFormExperimentConfig } from './solidFormExperiment';

// features
export * from './requireEmailConsentAsknebulaFeature';
export * from './requireEmailConsentFeature';
export * from './phoneNumberFeature';
export * from './redirectToAsknebulaFeature';
// experiments
export * from './restoreSubscriptionExperiment';
export * from './solidFormExperiment';
export * from './didnotOpenReadingExperiment';
export * from './openedReadingExperiment';

export const featureFlagsConfig: FeatureFlagsConfig = {
  features: {
    [requireEmailConsentFeature]: requireEmailConsentFeatureConfig,
    [requireEmailConsentAsknebulaFeature]: requireEmailConsentAsknebulaFeatureConfig,
    [phoneNumberOptInFeature]: phoneNumberOptInFeatureConfig,
    [redirectToAsknebulaFeatureName]: redirectToAsknebulaFeatureConfig,
    [restoreSubscriptionExperiment]: restoreSubscriptionExperimentConfig,
    [solidFormExperiment]: solidFormExperimentConfig,
    [didNotOpenReadingExperiment]: didNotOpenReadingExperimentConfig,
    [openedReadingExperiment]: openedReadingExperimentConfig,
  },
};
